import React, { useState, useRef } from "react";
import { useParams, Link } from "react-router-dom";

import { useSnackbar } from 'notistack';
import { Auth, API } from "aws-amplify";
import Button from "@material-ui/core/Button";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import { makeStyles } from '@material-ui/core/styles';
import LoadingWrapper from '../components/LoadingWrapper';
import AnmodningInformation from "../components/Anmodning._Information";
import LogInformation from "../components/Anmodning._LogInformation"
import SvarXml from "../components/Anmodning._SvarXml";
import MapApp from "../components/MapApp";
import RestartAnmodning from '../components/Anmodning._RestartAnmodning';
import ErrorFeatureList from '../components/Anmodning._ErrorFeatureList';
import StatusBanner from '../components/StatusBanner';
import AutoRefresh from '../components/AutoRefresh';
import bbox from '@turf/bbox';

import "../config";
import { isEmpty } from "../libs/isEmpty";
import { layerKomponentCircle, layerKomponentFill, layerKomponentFillId, layerKomponentId, otherId, other_fill, layerLedning, layerLedningId, anmodning_id, anmodning_fill } from "../libs/mapStyles"
import { LERPopupContents, OtherPopupContents } from '../components/Anmodning._PopupContents';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1
  },

  button: {
    margin: '15px',
    width: '150px'
  },
  containerAnmodning: {
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
    gridGap: '10px',
    margin: '10px 0 0 0 !important',
    minHeight: '600px',
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  },
  mapItem: {
    gridColumn: '1 / 8',
    gridRow: 1,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
    },
  },

  mapItemFullWidth: {
    gridColumn: '1 / 13',
    gridRow: 1,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
    },
  },

  actionItem: {
    zIndex: 1,
    gridColumn: '8 / 13',
    gridRow: 2,
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
      gridRow: 2,
    },
  },

  errorItem: {
    gridColumn: '8 / 13',
    gridRow: 1,
    maxHeight: '500px',
    overflow: 'auto',
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
      gridRow: 3,
      maxHeight: 'none',
      overflow: 'visible',
    },
  },

  informationItem: {
    gridColumn: '1 / 8',
    gridRow: 2,
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
      gridRow: 4,
    },
  },

  svarXmlItem: {
    gridColumn: '1 / 13',
    gridRow: 4,
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
      gridRow: 6,
    },
  },

  logContainer: {
    gridColumn: '1 / 13',
    gridRow: 3,
    [theme.breakpoints.down('md')]: {
      gridColumn: '1',
      gridRow: 5,
    },
  },

}));


export default function Anmodning(props) {
  let { id } = useParams();
  const defaultAnmodning = {}
  const classes = useStyles();
  const mapRef = useRef(null);
  const isAdmin = props?.isAdmin || false;

  const [isLoading, setIsLoading] = useState(false);

  const [isError, setIsError] = useState([false, '']);

  const [anmodning, setAnmodning] = useState(() => {
    if (id) {
      loadAnmodning()
    } else {
      return defaultAnmodning
    }
  });


  // Snackbar
  const { enqueueSnackbar } = useSnackbar();

  async function loadAnmodning() {
    // First get stuff from API
    setIsLoading(true)
    await getAnmodning(id)
      .then(response => {
        setAnmodning((response.data))
        setIsError([false, '']);
      })
      .catch(response => {
        enqueueSnackbar('Kunne ikke hente anmodning: ' + id, { variant: 'error', })
        setIsError([true, response.messsage])
        setAnmodning(defaultAnmodning)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  async function getAnmodning(anmod_id) {

    let init = {
      headers: { Authorization: `Bearer ${(await Auth.currentSession()).getIdToken().getJwtToken()}` }
    }
    return await API.post("API", "/Anmodning/" + anmod_id, init);
  }

  async function refresh() {
    if (id) {
      await loadAnmodning();
    }
  }

  function isFinalStatus(status) {
    return status === 'Gennemført' || status === 'Håndteret Manuelt';
  }

  function getLayers() {
    var layers = [];

    if (anmodning) {

      // Load geojson data from anmodning
      const anmod_data = anmodning['anmodning_geojson'];
      const vendor_data = anmodning['vendor_data_geojson'];

      //console.log('Anmodning data:', anmod_data);
      //console.log('Vendor data:', vendor_data);
      //console.log('anmodning:', anmodning);
      
      // Add anmodning geojson
      if (anmod_data && anmod_data.features) {
        layers.push({
          geojson: anmod_data,
          id: anmodning_id,
          style: [anmodning_fill],
          interactive: false
        });
      }

      // Split vendor data into lines, points and polygons
      if (vendor_data && vendor_data.features) {
        const line_features = { type: "FeatureCollection", features: [] };
        const point_features = { type: "FeatureCollection", features: [] };
        const polygon_features = { type: "FeatureCollection", features: [] };
        const polygon_others = { type: "FeatureCollection", features: [] };

        vendor_data.features.forEach(feature => {
          if (feature.geometry) {
            if (feature.geometry.type === "LineString" || feature.geometry.type === "MultiLineString") {
              line_features.features.push(feature);
            } else if (feature.geometry.type === "Point" || feature.geometry.type === "MultiPoint") {
              point_features.features.push(feature);
            } else if (feature.geometry.type === "Polygon" || feature.geometry.type === "MultiPolygon") {
              // if the translated_properties is an empty object and error_msg is null, put in others
              const translated_properties = feature.properties ? feature.properties['translated_properties'] : null;
              const error_msg = feature.properties ? feature.properties['error_msg'] : null;
              if (translated_properties && Object.keys(translated_properties).length === 0 && !error_msg) {
                polygon_others.features.push(feature);
              } else {
                polygon_features.features.push(feature);
              }
            }
          }
        });

        // Tilføj ledninger
        if (line_features.features.length > 0) {
          layers.push({
            geojson: line_features,
            id: layerLedningId,
            style: [layerLedning],
            popupTemplate: (properties) => LERPopupContents(properties, id),
          });
        }

        // Tilføj punkter
        if (point_features.features.length > 0) {
          layers.push({
            geojson: point_features,
            id: layerKomponentId,
            style: [layerKomponentCircle],
            popupTemplate: (properties) => LERPopupContents(properties, id),
          });
        }

        // Tilføj polygoner
        if (polygon_features.features.length > 0) {
          layers.push({
            geojson: polygon_features,
            id: layerKomponentFillId,
            style: [layerKomponentFill],
            popupTemplate: (properties) => LERPopupContents(properties, id),
          });
        }

        // Tilføj "other"
        if (polygon_others.features.length > 0) {
          layers.push({
            geojson: polygon_others,
            id: otherId,
            style: [other_fill],
            popupTemplate: (properties) => OtherPopupContents(properties, id),
          });
        }
      }
    }

    return layers;
  }

  function handleErrorFeatureClick(feature) {
    if (!mapRef.current) return;
    
    try {
      const map = mapRef.current.getMap();
      if (!map) return;

      // Calculate bounds for the feature
      const featureCollection = {
        type: 'FeatureCollection',
        features: [feature]
      };
      const bounds = bbox(featureCollection);
      
      // Calculate center coordinates for the sidebar
      let centerLng, centerLat;
      
      // If it's a point, just center on it with a higher zoom
      if (feature.geometry.type === 'Point' || feature.geometry.type === 'MultiPoint') {
        const coords = feature.geometry.type === 'Point' 
          ? feature.geometry.coordinates 
          : feature.geometry.coordinates[0];
        
        centerLng = coords[0];
        centerLat = coords[1];
        
        map.flyTo({
          center: coords,
          zoom: 18,
          duration: 1000
        });
      } else {
        // For lines and polygons, fit to bounds with less padding to zoom closer
        // Extend bounds slightly to provide some context
        const lonExtent = (bounds[2] - bounds[0]) * 0.2; // 20% extension
        const latExtent = (bounds[3] - bounds[1]) * 0.2;
        
        // Calculate center
        centerLng = (bounds[0] + bounds[2]) / 2;
        centerLat = (bounds[1] + bounds[3]) / 2;
        
        const extendedBounds = [
          [bounds[0] - lonExtent, bounds[1] - latExtent],
          [bounds[2] + lonExtent, bounds[3] + latExtent]
        ];
        
        map.fitBounds(
          extendedBounds,
          {
            padding: 50,
            duration: 1000,
            maxZoom: 18
          }
        );
      }

      // Determine the layer/source for this feature based on geometry type
      let sourceLayer = null;
      const geomType = feature.geometry.type;
      
      if (geomType === 'LineString' || geomType === 'MultiLineString') {
        sourceLayer = layerLedningId;
      } else if (geomType === 'Point' || geomType === 'MultiPoint') {
        sourceLayer = layerKomponentId;
      } else if (geomType === 'Polygon' || geomType === 'MultiPolygon') {
        // Check if it's an "other" polygon
        const translated_properties = feature.properties?.translated_properties;
        const error_msg = feature.properties?.error_msg;
        if (translated_properties && Object.keys(translated_properties).length === 0 && !error_msg) {
          sourceLayer = otherId;
        } else {
          sourceLayer = layerKomponentFillId;
        }
      }

      // Format the feature to match map click format
      const formattedFeature = {
        ...feature,
        source: sourceLayer,
        layer: { id: sourceLayer },
        state: {}
      };

      // Show feature in sidebar
      if (mapRef.current.showFeatureInSidebar) {
        mapRef.current.showFeatureInSidebar([formattedFeature], {
          longitude: centerLng,
          latitude: centerLat
        });
      }
      
    } catch (error) {
      console.error('Error zooming to feature:', error);
    }
  }

  return (
    <>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <AutoRefresh 
          onRefresh={refresh} 
          disabled={!id || isLoading || isFinalStatus(anmodning?.anmod_status)} 
        />
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to="/"
          type="button"
          disabled={isLoading}
        >
          Tilbage
        </Button>
      </div>
      
      {isError[0] && (
        <Card 
          raised
          style={{ 
            backgroundColor: '#d32f2f', 
            marginBottom: '16px',
            marginTop: '16px'
          }}
        >
          <CardContent>
            <div style={{ color: '#ffffff' }}>
              <div style={{ fontWeight: 600, fontSize: '16px', marginBottom: '8px' }}>
                Kunne ikke indlæse anmodning
              </div>
              <div style={{ fontSize: '14px', opacity: 0.95 }}>
                Der opstod en fejl ved indlæsning af anmodning {id}. Kontakt venligst support på ler@geopartner.dk og oplys anmodningsid.
              </div>
            </div>
          </CardContent>
        </Card>
      )}
      
      {!isError[0] && <StatusBanner status={anmodning?.anmod_status} />}
      
      {!isError[0] && (
      <LoadingWrapper isLoading={isLoading} minHeight="600px">
      <div className={classes.containerAnmodning}>
      <Card raised className={anmodning?.vendor_data_geojson?.features?.some(f => f.properties?.error_msg) ? classes.mapItem : classes.mapItemFullWidth}>
        {isEmpty(anmodning) ? (
          <CardContent><p>No data</p></CardContent>

        ) : (

          <CardContent style={{ display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0, padding: 0 }}>

            <MapApp
              ref={mapRef}
              className={classes.media}
              clickable={true}
              layer={getLayers()}
              height="500px"
            />
          </CardContent>
        )}
      </Card>
      {(isAdmin || !isFinalStatus(anmodning?.anmod_status)) && (
        <Card raised className={classes.actionItem} >
          <CardContent>
            <RestartAnmodning anmodning={anmodning} onAccecpt={loadAnmodning} infoTxt="Vælg metode og tryk genstart" status={anmodning?.anmod_status} />
          </CardContent>
        </Card>
      )}
      {anmodning?.vendor_data_geojson?.features?.some(f => f.properties?.error_msg) && (
        <Card raised className={classes.errorItem}>
          <CardHeader title={`Fejl i data (${anmodning.vendor_data_geojson.features.filter(f => f.properties?.error_msg).length})`} />
          <CardContent style={{ paddingTop: 0 }}>
            <ErrorFeatureList 
              geojson={anmodning?.vendor_data_geojson} 
              onFeatureClick={handleErrorFeatureClick}
            />
          </CardContent>
        </Card>
      )}
      {isAdmin && (
        <>
          <Card raised className={classes.logContainer} >
            <LogInformation Anmodning={anmodning} />
          </Card>
          <Card raised className={classes.svarXmlItem}>
            <SvarXml Anmodning={anmodning} />
          </Card>
        </>
      )}
      <Card raised className={classes.informationItem} >
        <AnmodningInformation
          Anmodning={anmodning}
        />
      </Card>
      </div>
      </LoadingWrapper>
      )}
    </>
  );
}